import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
`;

export const Container = styled.div`
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const Summary = styled.p`
  padding: 7px 15px;
  color: ${COLORS.GRAY_TEXT};
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 19px;
  }
`;

export const Ubigeo = styled.span`
  span {
    font-weight: 600;
  }
`;

export const Count = styled.span`
  font-weight: 600;
`;

export const Result = styled.div`
  min-height: 400px;
  margin-bottom: 25px;
  border-top: 1px solid ${COLORS.GRAY_LIGHT};
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 75px;
    ul{
      border-right: 1px solid ${COLORS.GRAY_LIGHT};
      border-left: 1px solid ${COLORS.GRAY_LIGHT};
    }
  }
`;

export const NotFound = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1600px;
`;

export const Item = styled.li`
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.BLACK};
  padding: 12px 16px;
  font-size: 12px;
  line-height: 21px;
  border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 15px 20px;
    font-size: 16px;
    line-height: 28px;
  }
`;

export const Text = styled.div`
  display: flex;
  align-items: flex-start;
  svg {
    flex: 0 0 12px;
    margin: 4px 8px 0 0;
  }
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    svg {
      width: 15px;
      height: 15px;
      margin-right: 12px;
    }
  }
`;

export const Name = styled.h2`
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
  margin-bottom: 12px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
    line-height: 25px;
  }
`;
